import React, {useEffect, useState} from 'react';
import {numberWithCommas, numberWithCommasNull} from "../../helpers/numberWithCommas";
import Link from "next/link";
import MainButton from "./MainButton";
import axios from "axios";

const Progress = ({t}) => {

    const progress = t('common:progress', {}, {returnObjects: true});

    const [apiData, setApiData] = useState({
        current_token_price: "0",
        next_token_price: "0",
        percent_tokens: "0",
        percent_usd: "0",
        stage_name: "Stage 1",
        tokens_left_by_stage: "0",
        tokens_sold: "0",
        total_tokens: "0",
        total_usd: "0",
        usd_raised: "0"
    });

    const getData = async () => {
        return await axios.get('/api/get-data', {
            headers: {
                "Content-Type": "application/json",
            },
        })
    }

    useEffect(() => {
        let apiData = getData().then(data => {
            setApiData(data.data)
        }).catch(() => {
            setApiData({
                current_token_price: "0",
                next_token_price: "0",
                percent_tokens: "0",
                percent_usd: "0",
                stage_name: "Stage 1",
                tokens_left_by_stage: "0",
                tokens_sold: "0",
                total_tokens: "0",
                total_usd: "0",
                usd_raised: "0"
            })
        })
    }, [])

    return (
        <section className={'progress_section'}>
            <div className="container">
                <div className="progress">
                    <div className={'progress_top'}>
                        <div className={'stage'}>
                            <span>{progress.stage} {apiData?.stage_name?.split(' ')[1]}</span>
                            <span>{progress.presale}</span>
                        </div>
                        <div className={'total'}>
                            <span>{progress.raised}</span>
                            <span>${numberWithCommas(Number(apiData?.usd_raised).toFixed(0))}</span>
                        </div>
                    </div>
                    <div className={'progress_bar_titles'}>
                        <span>{progress.total_sold}</span>
                        <span>{progress.remaining}</span>
                    </div>
                    <div className="progress_bar" style={{"--prog": `${apiData?.percent_tokens}%`}}>
                        <div className="pct_sold">
                            <div className="pct_sold_value">{Number(apiData?.percent_tokens).toFixed(2)}<span className={'pct'}>%</span></div>
                        </div>
                        <div className="pct_sold">
                            <div className="pct_sold_value">{Number(100 - +apiData?.percent_tokens).toFixed(2)}<span className={'pct'}>%</span>
                            </div>
                        </div>
                    </div>
                    <div className={'progress_details'}>
                        <div className="progress_details_items">
                            <div className={'details_item'}>
                                <span className={'details_item_title'}>{progress.price}</span>
                                <span className={'details_item_value'}>{+apiData?.current_token_price || '0.00'} <span className={'ccy'}>USDT</span></span>
                            </div>
                            <div className={'details_item'}>
                                <span className={'details_item_title'}>{progress.sold}</span>
                                <span
                                    className={'details_item_value'}>{numberWithCommasNull(Number(apiData?.tokens_sold).toFixed(2))}</span>
                            </div>
                            <div className={'details_item'}>
                                <span className={'details_item_title'}>{progress.next_price}</span>
                                <span className={'details_item_value'}>{+apiData?.next_token_price || '0.00'} <span className={'ccy'}>USDT</span></span>
                            </div>
                        </div>
                        <div className="progress_details_cta">
                            <Link className={'main_button'} href={process.env.NEXT_PUBLIC_APP_URL}>
                                {/*<MainButton*/}
                                {/*    title={progress.buy_cta}*/}
                                {/*/>*/}
                                {progress.buy_cta}
                            </Link>
                            <Link className={'how_to_cta'} href={'/how-to-buy'}>
                                {progress.how_cta}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Progress;